<template lang="pug">
  main.main.main_chat
    header.main__header
      h1.main__text {{ $t('chat.title') }}
    .main__container
      form.form.form_chat.main__form(@submit.prevent="submitForm")
        .form__field
          label.form__label {{ $t('chat.labels.name') }}
          input.form__input(type="text", v-model="name")
        .form__field
          label.form__label(v-html="$t('chat.labels.email')")
          input.form__input(
            type="email",
            v-model="$v.email.$model",
            :class="{'form__input_error': !$v.email.email}")
          .form__error(v-if="!$v.email.email") {{ $t('chat.errors.email') }}
        .form__submit
          input.button.form__submit(
            :value="$t('chat.submit')"
            type='submit'
            :disabled="$v.$invalid")
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
export default {
  name: 'Chat',
  data () {
    return {
      name: ''
    }
  },
  validations: {
    email: {
      required,
      email
    }
  },
  computed: {
    email: {
      get () {
        return this.$store.getters.getEmail
      },
      set (value) {
        this.$store.commit('updateEmail', value)
      }
    }
  },
  methods: {
    submitForm () {
      this.$store.dispatch('requestChat', this.name).then(
        response => {
          console.log(response)
        }, error => {
          console.log(error)
        }
      )
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Chat.vue